import { AVATARS } from './assets';

export const AVATAR_CHOICES = AVATARS;

export const interestOptions = ['Drama', 'Comedy', 'Action', 'Romance', 'Thriller', 'Documentary', 'Podcasts', 'Kids', 'Reality', 'African Cinema', 'Sci-Fi', 'Live Sports', 'Music', 'True Stories', 'Business', 'Culture'];

export const territories = [
  { code: 'NG', name: 'Nigeria' }, { code: 'GH', name: 'Ghana' }, { code: 'KE', name: 'Kenya' }, { code: 'ZA', name: 'South Africa' },
  { code: 'US', name: 'United States' }, { code: 'GB', name: 'United Kingdom' }, { code: 'FR', name: 'France' }, { code: 'DE', name: 'Germany' }, { code: 'IN', name: 'India' }, { code: 'BR', name: 'Brazil' },
];

export const LANGS = ['English', 'French', 'Portuguese', 'Swahili', 'Yoruba', 'Hausa', 'Pidgin', 'Twi', 'Zulu'];
export const MATURITY = ['All', 'PG', '13+', '16+', '18+'];
